<template>

  <div class="menu-container">

    <ul class="answer-type-options">
      <li class="option-header">Question Type</li>
      <li @mouseover="hovered_index=0" @click="addQuestion('multi_choice')">📊 Multi-Choice</li>
      <li @mouseover="hovered_index=1" @click="addQuestion('video')">🎬 Video</li>
      <li @mouseover="hovered_index=2" @click="addQuestion('image')">📷 Image</li>
      <li @mouseover="hovered_index=3" @click="addQuestion('audio')">🎙 Audio</li>
      <li @mouseover="hovered_index=4" @click="addQuestion('multimedia')">▶️ Multimedia</li>
      <li @mouseover="hovered_index=5" @click="addQuestion('text')">✏️ Text</li>
      <li @mouseover="hovered_index=6" @click="addQuestion('location')">📍 Location</li>
      <li @mouseover="hovered_index=7" @click="addQuestion('nps')">⚖️ NPS</li>
      <li @mouseover="hovered_index=8" @click="addQuestion('say')">💬 Content</li>
    </ul>

    <div class="answer-type-description">
      <div class="answer-type-gif" :class="getAnswerTypeClass(hovered_index)"></div>
      <p class="answer-type-title">{{ answer_type_info[hovered_index].title }}</p>
      <p class="answer-type-description">{{ answer_type_info[hovered_index].description }}</p>
    </div>

  </div>

</template>

<script>

export default {

  name: 'NewQuestionDropdown',

  props: {
    insert_at_index: Number,
    should_change_answer_type: Boolean
  },

  data: function () {
    return {
      hovered_index: 0,
      answer_type_info: [
        {
          title: 'Multi-Choice',
          description: 'Ask your respondents to choose between multiple, pre-defined answers.',
        },
        {
          title: 'Video',
          description: 'Ask your respondents to record a video.'
        },
        {
          title: 'Image',
          description: 'Ask your respondents to take a photo.'
        },
        {
          title: 'Audio',
          description: 'Ask your respondents to record some audio.'
        },
        {
          title: 'Multimedia',
          description: 'Let your respondents choose whether to record a video, take a photo or record some audio.'
        },
        {
          title: 'Text',
          description: 'Ask your respondents to write an open-ended text answer'
        },
        {
          title: 'Location',
          description: 'Ask your respondents to share their current location'
        },
        {
          title: 'NPS',
          description: 'Ask your respondents to answer an NPS question'
        },
        {
          title: 'Content',
          description: 'Say something (text, image or video) without requiring an answer'
        }
      ]
    }
  },

  computed: {

  },

  components: {},

  methods: {

    addQuestion(answer_type) {

      if (this.should_change_answer_type) {
        this.$store.commit('updateQuestionAnswerType', { new_answer_type: answer_type, question_index: this.insert_at_index });
      } else {

        // Adding new question inbetween other questions
        if (this.insert_at_index !== undefined) {
          let insert_at = this.insert_at_index + 1;
          this.$store.commit('addQuestionBlock', { answer_type, insert_at_index: insert_at });
          this.$emit('focusCard', insert_at);

        // Adding new question to the end.
        } else {
          this.$store.commit('addQuestionBlock', { answer_type });
          let questions_length = this.$store.state.new_survey.questions.length - 1;
          this.$emit('focusCard', questions_length);
        };
      };


      this.$emit('hide');

    },

    getAnswerTypeClass(hovered_index) {
      if (hovered_index === 0) {
        return 'multi';
      } else if (hovered_index === 1) {
        return 'video';
      } else if (hovered_index === 2) {
        return 'image';
      } else if (hovered_index === 3) {
        return 'audio';
      } else if (hovered_index === 4) {
        return 'multimedia';
      } else if (hovered_index === 5) {
        return 'text';
      } else if (hovered_index === 6) {
        return 'location';
      } else if (hovered_index === 7) {
        return 'nps';
      } else if (hovered_index === 8) {
        return 'say';
      };
    },

  }

}
</script>

<style scoped lang="scss">

.menu-container{
  width: 450px;
  height: 385px;
  padding: 0px;
  background-color: white;
  border: 1px solid rgb(230,230,230);
  border-radius: 6px;
  display: flex;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  font-family: "system-ui";
}

.answer-type-options{
  padding: 0px;
  padding-top: 15px;
  li{
    width: 160px;
    padding: 7px 15px 7px 20px;
    list-style: none;
    font-size: 14px;
    font-weight: 600;
    color: black;
    padding-left: 20px;
    cursor: default;

    &.option-header{
      margin-bottom: 5px;
    }
    &:not(.option-header) {
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      &:hover{
        background-color: rgb(244,244,244);
      }
    }
  }
}

.answer-type-description{
  flex-grow: 1;
  background-color: rgb(240,240,240);
  padding: 20px;

  .answer-type-gif{
    width: 100%;
    height: 130px;
    margin-bottom: 15px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 3px 4px;
    border-radius: 4px;
    &.multi{
      background-image: url("../../assets/icons/answer-type-gifs/multi.gif");
    }
    &.video{
      background-image: url("../../assets/icons/answer-type-gifs/video.gif");
    }
    &.image{
      background-image: url("../../assets/icons/answer-type-gifs/image.gif");
    }
    &.audio{
      background-image: url("../../assets/icons/answer-type-gifs/audio.gif");
    }
    &.multimedia{
      background-image: url("../../assets/icons/answer-type-gifs/video.gif");
    }
    &.text{
      background-image: url("../../assets/icons/answer-type-gifs/text.gif");
    }
    &.location{
      background-image: url("../../assets/icons/answer-type-gifs/location.gif");
    }
    &.nps{
      background-image: url("../../assets/icons/answer-type-gifs/image.gif");
    }
    &.say{
      background-image: url("../../assets/icons/answer-type-gifs/say.gif");
    }
  }

  p{
    color: rgb(30,30,30);
  }

  .answer-type-title{
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .answer-type-description{
    font-size: 14px;
    font-weight: 400;
    padding: 0;
  }

}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.menu-container{
  width: 170px;
}

.answer-type-description{
  display: none;
}


}


</style>
